export default IconCylinderPlus => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-cylinder-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 6m-7 0a7 3 0 1 0 14 0a7 3 0 1 0 -14 0" />
  <path d="M5 6v12c0 1.657 3.134 3 7 3c.173 0 .345 -.003 .515 -.008m6.485 -8.992v-6" />
  <path d="M16 19h6" />
  <path d="M19 16v6" />
</svg>`;